import { render, staticRenderFns } from "./CouponPopupDetail.vue?vue&type=template&id=6829ff96&scoped=true&"
import script from "./CouponPopupDetail.vue?vue&type=script&lang=ts&"
export * from "./CouponPopupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPopupDetail.vue?vue&type=style&index=0&id=6829ff96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829ff96",
  null
  
)

export default component.exports